import i18next from "i18next";
import { isEmpty } from "Shared/helpers/stringHelper";
import { Rule } from "./ValidationTypes";

export const createIsNumberRule = (message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Number required"),
		validateImmediately,
	},
	type: "number",
	validate: async (value) => !isEmpty(value) && !isNaN(Number(value)),
});

export const createLengthRule = (length: number, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("Este campo debe tener {{length}} caracteres de longitud.", { length }),
		validateImmediately,
	},
	type: "length",
	validate: async (value) => {
		if (Array.isArray(value)) {
			return value?.length === length;
		} else {
			return value?.toString()?.length === length;
		}
	},
});

export const createMaxRule = (max: number, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("La longitud máxima es de {{max}} caracteres.", { max }),
		validateImmediately,
	},
	type: "max",
	validate: async (value) => {
		if (isEmpty(value?.toString())) return true;
		if (typeof value === "number") return value <= max;
		if (Array.isArray(value)) return value.length <= max;
		return value?.toString().length <= max;
	},
});

export const createMinRule = (min: number, message?: string, validateImmediately?: boolean): Rule => ({
	message: {
		text: message ?? i18next.t("La longitud mínima es de  {{min}} caracteres.", { min }),
		validateImmediately,
	},
	type: "min",
	validate: async (value) => {
		if (isEmpty(value?.toString())) return true;
		if (typeof value === "number") return value >= min;
		if (Array.isArray(value)) return value.length >= min;
		return value?.toString().length >= min;
	},
});
